import { CheckPicker, SelectPicker } from "rsuite";
import { numberFormatter } from "../../utils";
import CategoryScatter from "./category-scatter";
import "./profitability.scss";
import React, { useState, useEffect, useRef } from "react";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { CSVLink } from "react-csv";
import { topSupplierCount } from "../constants";
import html2canvas from "html2canvas";

const Summary = (props: any) => {
	const {
		viewFor,
		setViewFor,
		isVisible,
		summaryView,
		data,
		exportData,
		view,
		selected,
		recommended,
		filters,
		handleClick,
		highlight,
		updateHighlight,
		selectedSupplierCount,
		updateSelectedSupplierCount,
	} = props;

	const kpiData = data;
	const { exportData: exportDataProp, view: viewProp } = props;

	let scatterData = [];
	if (kpiData?.scatterData) {
		scatterData = kpiData?.scatterData.map((data: any) => {
			return {
				grossMargin: data.scatterData.grossMargin * 100,
				cagr: data.scatterData.cagr * 100,
				cost: data.cost,
				revenue: data.revenue,
				category: data.category,
				type: data.type,
			};
		});
	}

	return (
		<>
			<div
				className={`summary-flex ${
					isVisible ? "h-[36vh]" : "h-[48vh]"
				}`}
			>
				
				<div className="quadrants w-full">
					{[
						{
							category: "Grow Market Share",
							color: "#c79c38",
							key: "growthPotential",
						},
						{
							category: "Re-assess and Fix",
							color: "#d55454",
							key: "lowPerformers",
						},
					].map((quad: any, index: number) => {
						// Define background colors with 6% opacity for each category
						const backgroundColor =
							quad.category === "Grow Market Share"
								? "#FEFAF1"
								: "#FAE9E9";

						return (
							<div
								key={quad.category}
								className="kpi-table flex flex-col bg-white box-shadow-card mx-2"
								style={{ border: "1px solid #bebebe" }}
							>
								<div
									className="flex justify-start items-center table-header-title py-[1.5vh] px-2 border-b-2 font-bold"
									style={{
										borderBottomColor: quad.color,
										color: "black",
									}}
								>
									{quad.category}
								</div>
								<div className="flex justify-between items-center px-2 py-[1vh] border-t  table-cell-title border-gray-300 text-black">
									<span className="text-left">Cost</span>
									<span className="text-right font-normal">
										{numberFormatter(
											kpiData[quad.key].cost,
											kpiData[quad.key].cost > 1000000000
												? 1
												: 0,
											"$"
										)}
									</span>
								</div>
								<div
									className="flex justify-between items-center px-2 py-[1vh] border-t table-cell-title border-gray-300 text-black"
									style={{ backgroundColor: backgroundColor }}
								>
									<span className="text-left">Sales</span>
									<span className="text-right font-normal">
										{numberFormatter(
											kpiData[quad.key].revenue,
											kpiData[quad.key].revenue >
												1000000000
												? 1
												: 0,
											"$"
										)}
									</span>
								</div>
								<div className="flex justify-between items-center px-2 py-[1vh] border-t table-cell-title border-gray-300 text-black">
									<span className="text-left">
										# of Suppliers
									</span>
									<span className="text-right font-normal">
										{kpiData[quad.key].noOfSuppliers}
									</span>
								</div>
							</div>
						);
					})}
				</div>

				<div
					className="scatter relative gap-3 box-shadow-card w-[75%] h-full"
					style={{ border: "0.5px solid #bebebe" }}
				>

					<CategoryScatter
						data={scatterData}
						text="SUMMARY"
						refX={props.data.cagr * 100}
						refY={props.data.grossMargin * 100}
						view={props.view}
						recommended={props.recommended}
						handleClick={(selected: string | null) =>
							props.handleClick(selected)
						}
						highlight={props.highlight}
					/>

					{/* <span className="note-text">
						{props.view === "Supplier" &&
							"*Note: The above chart shows only top 250 suppliers by spend"}
					</span> */}
				</div>

				<div className="quadrants w-full">
					{[
						{
							category: "Protect and Expand",
							color: "#008b00",
							key: "growCategory",
						},
						{
							category: "Improve Margin",
							color: "#60b5bf",
							key: "profitabilityOpp",
						},
					].map((quad: any, index: number) => {
						// Define background colors with 6% opacity for each category
						const backgroundColor =
							quad.category === "Protect and Expand"
								? "#EFF6E1"
								: "#E4F0F8";

						return (
							<div
								key={quad.category}
								className="kpi-table flex flex-col bg-white box-shadow-card mx-2"
								style={{ border: "1px solid #bebebe" }}
							>
								<div
									className="flex justify-start items-center py-[1vh] table-header-title px-4 border-b-2 font-bold"
									style={{
										borderBottomColor: quad.color,
										color: "black",
									}}
								>
									{quad.category}
								</div>
								<div className="flex justify-between items-center px-4 py-[1vh] table-cell-title  text-black">
									<span className="text-left">Cost</span>
									<span className="text-right font-normal">
										{numberFormatter(
											kpiData[quad.key].cost,
											kpiData[quad.key].cost > 1000000000
												? 1
												: 0,
											"$"
										)}
									</span>
								</div>
								<div
									className="flex justify-between items-center px-4 py-[1vh] table-cell-title text-black"
									style={{ backgroundColor: backgroundColor }}
								>
									<span className="text-left">Sales</span>
									<span className="text-right font-normal">
										{numberFormatter(
											kpiData[quad.key].revenue,
											kpiData[quad.key].revenue >
												1000000000
												? 1
												: 0,
											"$"
										)}
									</span>
								</div>
								<div className="flex justify-between items-center px-4 py-[1vh] table-cell-title text-black">
									<span className="text-left">
										# of Suppliers
									</span>
									<span className="text-right font-normal">
										{kpiData[quad.key].noOfSuppliers}
									</span>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</>
	);
};

export default Summary;
